<template>
  <!-- <div> -->
    <div>
      <button
          class="btn btn-sm btn-green"
          v-bind="$attrs"
          @click="pdf"
        >
        <i class="fa fa-print" style="color: #fff"></i>
          พิมพ์
          <!-- ใบรับมัดจำ -->
      </button>
    
      <pdf-viewer ref="pdfViewerRef"></pdf-viewer>
    </div>  
</template>


<script>

import PdfViewer from "../modals/forms/PdfViewer.vue";

export default {
  components: { PdfViewer },
  props: {
    aiCode: String,
    aiBranchID: Int32Array,
    srCode:String
    //partnerCode: String
  },
  methods: {
    pdf() {
      
       
        let url = "pdf/aivoucher/" + this.aiCode + "/"+(this.aiBranchID?this.aiBranchID.toString():"1")+"/"+this.srCode;
      

      this.$http
        .get(url, {
          responseType: "blob",
        })
        .then((res) => {
          console.log(res, res.data);
          var file = new Blob([res.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          //this.$emit("viewShow")
          this.$refs.pdfViewerRef.show({ url: fileURL });
        });
    },
  }
}
</script>

<style scoped>
  .btn-green {
    color: #fff;
    background-color:  #117a8b;
    /*border-color: #117a8b;*/
  }
  .btn-dark-green {
      color: #fff;
      background-color: #066f8f;
  }
</style>